import classnames from "gpages/utils/classnames"
import React from "react"
import ReactModal from "react-modal"
import * as styles from "./modal.module.scss"
import Clickable from "../clickable"
import Icon from "../icon"

if (typeof document === "object") {
  ReactModal.setAppElement(document.getElementById("___gatsby"))
}

const Modal = React.memo(({ red, children, onRequestClose, ...props }) => {
  return (
    <ReactModal
      className={classnames(styles.modalBase, {
        [styles.red]: red,
      })}
      overlayClassName={classnames(styles.modalOverlay)}
      shouldCloseOnOverlayClick
      onRequestClose={onRequestClose}
      {...props}
    >
      {children}
      <Clickable
        className={classnames(styles.modalClose)}
        onClick={() => {
          onRequestClose()
        }}
      >
        <Icon icon={red ? "close-black" : "close-red"} />
      </Clickable>
    </ReactModal>
  )
})

Modal.displayName = "Modal"
export default Modal
